import Avatar from '@/components/common/Avatar';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import FalconCloseButton from '@/components/common/FalconCloseButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface AiModalHeaderProps {
  keyword?: string;
  onClose: () => void;
}

const AiModalHeader = ({ keyword, onClose }: AiModalHeaderProps) => {
  return (
    <FalconCardHeader
      title={
        <>
          <div className="position-relative d-flex align-items-center">
            <div className="d-flex flex-1 gap-2 align-items-center">
              <Avatar
                name={
                  <FontAwesomeIcon
                    icon="comment"
                    size="lg"
                    className="text-primary"
                  />
                }
                isExact
                size="xl"
                className="border border-3 rounded-circle border-200"
              />
              تحلیل AI ({keyword ?? ''})
            </div>
            <FalconCloseButton onClick={onClose} />
          </div>
        </>
      }
      titleTag="h5"
      className="bg-body-tertiary"
    />
  );
};

export default AiModalHeader;
